import React, {useEffect, useContext, useState} from 'react'
import {Button, Card, Col, Row} from "antd";
import {useParams} from "@reach/router";
import {PurchaseContext} from "../../context/PurchaseContext";
import {getPurchaseById, updatePurchase} from "../../services/servicePurchase";
import PurchaseList from "./create/PurchaseList";
import PurchaseInfos from "./create/PurchaseInfos";
import {getStocksAsSelect} from "../../services/serviceStock";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const PurchaseEdit = () => {
    const {purchaseId} = useParams()
    const {purchaseItems, purchaseInfos, stocks} = useContext(PurchaseContext)
    const [, setStockList] = stocks
    const [purchaseList, setPurchaseList] = purchaseItems
    const [purchaseInformations, setPurchaseInformations] = purchaseInfos
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getPurchaseById(purchaseId)
            .then(({data}) => setContext(data))
    }, [])

    useEffect(() => {
        getStocksAsSelect()
            .then(({data}) => {
                if (data && data.length) {
                    const stockData = data.map(stock => ({
                        text: `${stock.value} - ${stock.label}`,
                        value: stock.key
                    }))
                    setStockList(stockData)
                }
            })
    }, [])

    const setContext = (data) => {
        if (data.contentOfPurchaseList) {
            const contentOfPurchaseList = data.contentOfPurchaseList.map((item, index) => {
                return {
                    key: index,
                    stock: item.stock.id,
                    unit: item.unit,
                    shippingDate: item.shippingDate,
                    quantity: `${item.quantity}`,
                    lock: true
                }
            })
            setPurchaseList(contentOfPurchaseList)
        }

        const purchaseInfo = {
            whom: data.whom,
            payment: data.payment,
            exchangeRate: data.exchangeRate,
            delivery: data.delivery
        }
        setPurchaseInformations(purchaseInfo)
    };
    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        const contentOfPurchaseList = purchaseList.map(item => {
            return {
                shippingDate: item.shippingDate,
                stock: {
                    id: item.stock,
                },
                quantity: item.quantity,
                unit: item.unit
            }
        })

        const requestObj = {
            id: purchaseId,
            contentOfPurchaseList: contentOfPurchaseList || [],
            delivery: purchaseInformations.delivery || '',
            payment: purchaseInformations.payment || '',
            whom: purchaseInformations.whom || '',
            exchangeRate: purchaseInformations.exchangeRate || ''
        }
        updatePurchase(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setTimeout(() => window.location.href = `${window.location.origin}/landing/purchase`, 500)
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Card
                title={'Satın Alma Güncelle'}
                extra={
                    <Button
                        onClick={handleSubmit}
                        loading={loadings[0]}
                        type={'primary'}
                    >
                        Kaydet
                    </Button>
                }
            >
                <PurchaseInfos/>
                <Row justify={'start'}>
                    <Col span={12}>
                        <h4>Satın Alma Listesi</h4>
                    </Col>
                </Row>
                <PurchaseList/>
            </Card>
        </React.Fragment>
    )
}
export default PurchaseEdit